import { render, staticRenderFns } from "./approval-multiple.vue?vue&type=template&id=0d80c27a&"
import script from "./approval-multiple.vue?vue&type=script&lang=js&"
export * from "./approval-multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports